// extracted by mini-css-extract-plugin
export var container = "TimeLeft-module--container--3db_3";
export var timeContainer = "TimeLeft-module--timeContainer--bJC8n";
export var timeUnitContainer = "TimeLeft-module--timeUnitContainer--1rM5c";
export var timeUnit = "TimeLeft-module--timeUnit--SqZkQ";